import { render, staticRenderFns } from "./PedidosForm.vue?vue&type=template&id=df75aef8&scoped=true&"
import script from "./PedidosForm.vue?vue&type=script&lang=js&"
export * from "./PedidosForm.vue?vue&type=script&lang=js&"
import style0 from "./PedidosForm.vue?vue&type=style&index=0&id=df75aef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df75aef8",
  null
  
)

export default component.exports